import walletApiDefinition from './api.js';
import { backedUpAtomDefinition } from './atoms/backed-up.js';
import walletDefinition from './module.js';
import walletPluginDefinition from './plugin.js';
const wallet = () => ({
    id: 'wallet',
    definitions: [
        {
            definition: backedUpAtomDefinition,
            storage: { namespace: 'wallet' },
            aliases: [
                { interfaceId: 'storage', implementationId: 'unsafeStorage' },
            ],
        },
        { definition: walletDefinition },
        { definition: walletApiDefinition },
        { definition: walletPluginDefinition },
    ],
});
export default wallet;
